import _http_v1 from '@packs/http_requests/_http_v1'
import store from '../../../store/main_config_store'

export default function MonthAcum(opts={}){
    BaseConstructor.call(this)
    let {container, station} = opts
    let elements = {}
    let context = this
    let clickable = true

    this.getElement = _ =>{
        return elements.container
    }

    this.generate = () =>{
        
    }

    this.update = () =>{

    }

    init()

    function init(){
        let start_date = moment(store.getDate() || undefined).startOf('month').format('YYYY-MM-DD')
        let end_date = moment(store.getDate() || undefined).endOf('month').format('YYYY-MM-DD')

        let months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez']
        
        elements.container = context.createElement('div', '', ``)
        elements.text = context.createElement('span', '', 'Acumulado do mês: ')
        elements.acum = context.createElement('span', 'font-weight-bold text-primary', '-')
        elements.bar = context.createElement('span', '', ' de ')
        elements.hist = context.createElement('span', 'font-weight-bold', '?')
        elements.unit = context.createElement('span', '', ' milímetros esperados')
        elements.month_name = context.createElement('span', 'text-capitalize', '')
        $(elements.container).append(elements.text, elements.acum,elements.bar, elements.hist,elements.unit,elements.month_name)
        _http_v1.request('measurements/grouped', 'get', {station_prefix_ids:[station.id], start_date: `${start_date} 03:00`, end_date: `${end_date} 02:59`, group_type: 'month'}).then(data=>{
            if(data.json.length > 0){
                let value = data.json[0].value
                $(elements.acum).html(`${value.toFixed(1)}`)
            }
        })
        _http_v1.request('historical_measurements/avg_from_point', 'GET', {lat:station.latitude || station.station.latitude, lng: station.longitude || station.station.longitude}).then(data=>{
            if(data){
                let date = moment(store.getDate() || undefined)
                let _date = date || moment()
                let avg = data['avg_' + months[_date.month()]]
                $(elements.hist).html((avg && avg != -99999) ? avg.toFixed(1) : '?')
                $(elements.month_name).html(` (${months[_date.month()]})`)
            } else {
                // $(elements.container).html('Erro :(')
            }
            
        })
    }
}

MonthAcum.prototype = Object.create(BaseConstructor.prototype)